import script from "./contactSet.vue?vue&type=script&setup=true&lang=js"
export * from "./contactSet.vue?vue&type=script&setup=true&lang=js"

import "./contactSet.vue?vue&type=style&index=0&id=c7f0c912&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7f0c912"]])

export default __exports__